import * as React from 'react';
import * as ReactDOM from 'react-dom';

import Form from '../../FormIO/presentation/FormWithValidations';
import { connect } from 'react-redux';
import * as urls from '../../shared/urls';
import './assets/DataTranscriberForm.scss';

interface IDataTranscriberFormOwnProps {
  readOnly?: boolean;
  data?: any;
  injectToSidebar?: any;
  formId: string;
  saving?: boolean;
}

export interface IDataTranscriberFormPropsFromState {
  serviceURL: string;
  formIOUrl: string;
}

export interface IDataTranscriberFormPropsFromActions { }

export type IDataTranscriberFormProps = IDataTranscriberFormOwnProps &
  IDataTranscriberFormPropsFromActions &
  IDataTranscriberFormPropsFromState;

export class DataTranscriberForm extends React.Component<
  IDataTranscriberFormProps,
  any
> {
  private form: any;
  
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.saving != prevProps.saving) {  
      this.formLoaded();
    }
  }

  logData = () => {
    if (this.form && this.form.getSubmission) {
      console.log(this.form.getSubmission());
    }
  };

  getFormData = () => {
    return this.form && this.form.getSubmission ? this.form.getSubmission() : null;
  };

  private wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

  flushPendingInputCommit = async () => {
    const active = document.activeElement as HTMLElement | null;
    if (active && typeof active.blur === 'function') {
      active.blur();
    }
    await this.wait(225);
  };

  getLatestFormData = async () => {
    await this.flushPendingInputCommit();
    return this.getFormData();
  };

  setFormData = (submission: any) => {
    if (this.form && this.form.setSubmission) {
      this.form.setSubmission(submission);
    }
  };

  formLoaded = () => {
    const divToLoad = document.createElement('div');
    divToLoad.id = 'divSidebarAppend';
    document
      .getElementsByClassName('sidebar--wrapper')[0]
      .appendChild(divToLoad);
    ReactDOM.render(
      this.props.injectToSidebar,
      document.getElementById('divSidebarAppend')
    );
  };


  render() {
    const { formIOUrl, data, formId } = this.props;

    return ( data && (data.data || data == "new") && (
      <div id='formio'>
        <div className='container DataTranscriberForm'>
          <Form
            formId={formId}
            ref={(form) => (this.form = form)}
            data={data}
            onRender={() => this.formLoaded()}
            handleValidation={false}
          />
        </div>
      </div>
    ) || <div>Loading</div>);
  }
}

const mapStateToProps = (reduxState: any) => {
  return {
    serviceURL: reduxState.Application.backendURL,
    formIOUrl: reduxState.Application.formIOUrl,
  };
};

const mapDispatchToProps = {};

export default connect<
  IDataTranscriberFormPropsFromState,
  IDataTranscriberFormPropsFromActions
>(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
  DataTranscriberForm
);
